

import noRight from './noRight/index'
const install = function (Vue) {

	
	Vue.directive('noRight', noRight)
}

if (window.Vue) {

	Vue.use(install); // eslint-disable-line
}

export default install
